import WalletAccountsTable from './WalletAccountsTable';

export default WalletAccountsTable;
